import React ,{useRef ,useEffect ,useState}from 'react';
import SecurityService from '../security/security.service';
import moment from 'moment'

import DynamicInputList from '../software-dynamic-version-2/list-input-v-2';
import DialogInput from '../software-dynamic-version-2/popup-dialog-input-v-2';


import FullPropertyAdd  from './full-property-add'
import FullPropertyService from './full-property.service';
import AuditTable from '../audit-table/audit-table';
import './full-property.scss'
import securityService from '../security/security.service';



const FullPropertyInput = (props) => {
    // let handleCheckboxChange = (e,props)=>{
    //   console.log(e)
    //   FullPropertyService.delete(props.UserID).then(async (res)=>{
    //     document.getElementById(`checkbox_${props.UserID}`).checked =false
    //     await  showDialog('ALERT' ,<span class="error-success">User Actived</span>)
    //       // await getListService()
    //       })
    // }
  
    let columns =[
      { field: "FullPropertyID", headerText:'Full Property ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "FullPropertyName", headerText:'Full Property Name', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "CompanyName", headerText:'Company Name', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // { field: "CompanyID", headerText:'Company ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "PropertyName", headerText:'Property Name', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // // { field: "PropertyID", headerText:'Property ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "PropertyOwnerName", headerText:'Owner Name', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // // { field: "PropertyOwnerID", headerText:'Owner ID', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "BuildingNo", headerText:'Building No', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      // // { field: "BuildingID", headerText:'Building ID', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "PropertyLocation", headerText:'Property Location', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // // { field: "PropertyLocationID", headerText:'Location ID', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "PropertyFloor", headerText:'Property Floor', width:'120px', textAlign:'left', headerTextAlign:'center', other:[] },
      // // { field: "PropertyFloorID", headerText:'Floor ID', width:'100px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "PropertyUnitType", headerText:'Unit Type', width:'150px', textAlign:'left', headerTextAlign:'center', other:[] },
      // // { field: "PropertyUnitTypeID", headerText:'Unit Type ID', width:'120px', textAlign:'right', headerTextAlign:'center', other:[] },
      { field: "PropertyUnitNo", headerText:'Unit No', width:'100px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "IsPropertyThirdParty", headerText:'Is Third Party', width:'120px', textAlign:'center', headerTextAlign:'center', other:[] },
      { field: "PropertyCoveredArea", headerText:'Covered Area', width:'120px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "PropertyDEWA", headerText:'DEWA', width:'120px', textAlign:'left', headerTextAlign:'center', other:[] },
      { field: "PropertyPlotNo", headerText:'Plot No', width:'120px', textAlign:'left', headerTextAlign:'center', other:[] }
    ];

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
          console.log(getListService )
          console.log(selectedRow )
    
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }
        if(args.requestType == 'save'){
          let data = {
            FullPropertyID: args.data.FullPropertyID,
            CompanyID: securityService.getCompanyIDLoggedInUserId(),
            PropertyID: args.data.PropertyID,
            PropertyOwnerID: args.data.PropertyOwnerID,
            BuildingID: args.data.BuildingID,
            PropertyLocationID: args.data.PropertyLocationID,
            PropertyFloorID: args.data.PropertyFloorID,
            PropertyUnitTypeID: args.data.PropertyUnitTypeID,
            PropertyUnitNo: args.data.PropertyUnitNo,
            IsPropertyThirdParty: args.data.IsPropertyThirdParty == false ? 0 : 1,
            PropertyCoveredArea: args.data.PropertyCoveredArea,
            PropertyDEWA: args.data.PropertyDEWA,
            PropertyPlotNo: args.data.PropertyPlotNo
        }
    
          console.log(data)
        if(args.action == 'add'){
          FullPropertyService.insert(data).then(async (res)=>{
            await getListService()
            // inputName ,tableName,tableID,values
            // addUserLog('FullProperty'  ,'FullProperty',selectedRow,{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        if(args.action == 'edit'){
          FullPropertyService.update(data).then((res)=>{
            getListService()
            // tableName,tableIDValue,selectedRows,values
            // editUserLog('FullProperty',args.data.UserID,'UserID',{
            //   UserName:args.data.UserName,
            //   UserFullName:args.data.UserFullName,
            // })
          })
        }
        }
        
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = true
    let  allowDataBound = true
    let  allowGridSum = false
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
        // @default FullProperty${typeMode} 
        let ListSecurity='Full Property'
        let AddSecurity='Full Property'
        let EditSecurity='Full Property'
        let DeleteSecurity='Full Property'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      // let toolbarOptions ='All';
      let toolbarOptions =['Add','Edit', 'Delete' ,'Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
          

        //   const dialogRef = useRef(null);
        //   const showDialog = (header,title,actions =['OK']) => {
        //     return new Promise((resolve) => {
        //     // Destroy existing dialog if any
        //     if (dialogRef.current) {
        //       dialogRef.current.destroy();
        //     }
        //     const okButtons = actions.map((action) => ({
        //       buttonModel: {
        //         content: action,
        //         cssClass: 'e-flat',
        //         isPrimary: action === 'OK',
        //       },
        //       click: (e) => {
        //         hideDialog();
        //         resolve(action);
        //       },
        //     }));
        //     // Create a new dialog instance
        //     dialogRef.current = new DialogInput({
        //       content: ()=>(<>{title}</>),
        //       header:header,
        //       width:'340px',
        //       showButtons: true,
        //       buttons:okButtons
        //     });
        //     // Show the dialog programmatically
        //     dialogRef.current.show();

        //   });

        //   };
        // const hideDialog = () =>{
        //   if (dialogRef.current) {
        //   }
        //   dialogRef.current.hide();
        //   dialogRef.current.destroy();
        //   dialogRef.current = null; // Clean up reference after destruction
        // }

      const toolbarClicking =  async (grid , args , selectedRow , getListService)=>{
        console.log(grid , args)
        console.log(selectedRow)
      //   if(props.Active ==  false  ){
      //      if(args.name == "rowSelected" || args.name == "rowDeselected"){
      //     if(args.target?.type ==  'checkbox'){
      //   setTimeout( async () => {
          
      //     await getListService()
      //   }, 1500);
      // }
      // }
    
      // }
      //   if(args?.item?.properties?.id == 'IsActive'){
      //     if(selectedRow == undefined){
      //   await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      // }else{
      //   let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
      //   console.log(dialogResult)
      // if(dialogResult == 'OK'){
      //   FullPropertyService.delete(selectedRow.UserID).then(async (res)=>{
      //   await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
      //     await getListService()
      //       AuditTable.auditDelete('FullProperty',selectedRow.UserID,{
      //         UserName:selectedRow.UserName,
      //         FullName:selectedRow.FullName,
      //       })
      //     })
      //   }
      //   }
      //   }
        
      }
      
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'FullProperty' ,
                    TableID:'FullPropertyID',
                   // Optional if Delete is Soft // TableSecurity:'FullPropertyDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'FullProperty' ,TableID:'FullPropertyID', Optional // TableSecurity:'FullPropertyDelete'}]
    let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
    //  let filterColumns = [{ field: 'IsActive', value: props?.Active == false ? 'No' : 'Yes' }];
     let filterColumns = [];
      

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
      
        <DynamicInputList
        Id='FullProperty'
        ListTitle='Full Property - List'
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> FullPropertyService.getFullPropertyForList(securityService.getCompanyIDLoggedInUserId())
                        }]}
        DefaultSortedColumnName={'FullPropertyID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<FullPropertyAdd GridID={'FullProperty'} CompanyID={securityService.getCompanyIDLoggedInUserId()} />
        
            }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            // ToolbarOption={toolbarOptions}
            AllowGrouping={allowGrouping}
            AllowExcelExport={allowExcelExport}
            AllowPdfExport={allowPdfExport} 
            ShowColumnChooser={showColumnChooser}
            AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            GroupColumns={groupColumns} 
            // ListDelete={listDelete}
             DeleteType={deleteType} 
            GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            // AllowGridSum={allowGridSum}
            IsDialog={isDialog}

            {...props}
            ></DynamicInputList>

            );
}



export default FullPropertyInput;
